<template>
  <div class="footer">
    <div class="nav">
      <div class="list" v-for="(item, index) in navList" :key="index" @click="routeChange(item)">
        {{ item.name }}
      </div>
    </div>
    <div class="copy">Copyright @ 2025. All rights reserved</div>
    <!-- <div class="copy">zhengrongzrfly</div> -->
  </div>
</template>

<script setup>
import { ref, watch } from "vue"
import { useI18n } from "vue-i18n"
const { t, locale } = useI18n()

import { useRouter } from 'vue-router'
const router = useRouter()

const navList = ref([
  { name: t("navList.home"), path: "/index" },
  { name: t("navList.compare"), path: "/compare" },
  { name: t("navList.intro"), path: "/introduce" },
  //{ name: t("navList.info"), path: "/info" },
  { name: t("navList.aboutUs"), path: "/about" }
])

const routeChange = (data) => {
  router.push(data.path)
}

watch(locale, () => {
  navList.value = [
    { name: t("navList.home"), path: "/index" },
    { name: t("navList.compare"), path: "/compare" },
    { name: t("navList.intro"), path: "/introduce" },
   // { name: t("navList.info"), path: "/info" },
    { name: t("navList.aboutUs"), path: "/about" }
  ]
})
</script>

<style lang="less" scoped>
.footer {
  color: #333;
  font-size: 14px;
  width: 100%;
  margin: 20px 0 0 0;
  .nav {
    display: flex;
    align-items: center;
    justify-content: center;
    .list {
      cursor: pointer;
      padding: 0 5px;
      border-right: 1px solid #999;
      &:last-child {
        border: none;
      }
    }
  }
  .copy {
    font-size: 12px;
    text-align: center;
    margin: 8px 0 5px 0;
  }
}
</style>
